import i18n from '@/i18n/i18n'

export function finalAccounts() {
	return [
		{ id: 1, name: i18n.t('final-accounts.operating') },
		{ id: 2, name: i18n.t('final-accounts.trading') },
		{ id: 3, name: i18n.t('final-accounts.profit-and-losses') },
		{ id: 4, name: i18n.t('final-accounts.balance-sheet') },
	]
}

export const finalAccount = {
	trading: 2,
	profitAndLosses: 3,
	budget: 4
}

export function types() {
	return [
		{ id: 1, name: i18n.t('type.main') },
		{ id: 2, name: i18n.t('type.sub') }
	]
}

export const type = {
	main: 1,
	sub: 2,
}
export function itemCategories() {
	return [
		{ id: 1, name: i18n.t('item-category.commodity') },
		{ id: 2, name: i18n.t('item-category.raw') },
		// { id: 3, name: i18n.t('item-category.indirect-raw') },
		// { id: 4, name: i18n.t('item-category.in-process') },
		// { id: 5, name: i18n.t('item-category.finished') },
		{ id: 6, name: i18n.t('item-category.manufactured') },
	]
}

export const itemCategoryType = {
	commodity: 1,
	raw: 2,
	manufactured: 6
}
export const accountType = {
	notDefined: 0,
	primary: 1,
	secondary: 2
}

export const accountConfigType = {
	sales: 1,
	purchases: 2,
	grantedDiscount: 3,
	vestedDiscount: 4,
	salesRefund: 8,
	purchasesRefund: 9,
	defaultCashCustomer: 11,
	defaultImporter: 10,
	vatAccountId: 12,
	BankAccountId: 13,
	BankFeeAccountId: 14,
	CashboxesReconciliation: 15
}

export const postingState = {
	posted: 1,
	notPosted: 2,
	all: 3,
}

export const invoiceTypes = {
	purchases: 1,
	sales: 2,
	purchasesRefund: 3,
	salesRefund: 4
}

export const paymentMethod = {
	cash: 1,
	debt: 2,
	creditCard: 3,
	internal: 4
}
export function paymentMethodArray() {
	return [
		{ id: 1, name: i18n.t('payment-method.cash') },
		{ id: 2, name: i18n.t('payment-method.debt') },
		{ id: 3, name: i18n.t('payment-method.creditCard') },
		{ id: 4, name: i18n.t('payment-method.internal') },
	]
}

export const dateSortMode = {
	ascending: 1,
	descending: 2,
}

export const statusStore = {
	NotDefined: 0,
	activated: 1,
	suspended: 2
}
export const statusStoreWithName = {
	notDefined: {
		id: 5,
		name: i18n.t('status-store.notDefined')
	},
	activated: {
		id: 0,
		name: i18n.t('status-store.Unarchived')
	},
	suspended: {
		id: 1,
		name: i18n.t('status-store.archived')
	}
}

export const journalType = {
	invoice: 1,
	cashbox: 2,
	postingCashboxBalance: 3,
	allWithoutInvoices: 4,
	all: 5
}

export const context = {
	notDefined: 0,
	invoice: 1,
	cashbox: 2,
	postingCashboxBalance: 3,
	allWithoutInvoices: 4,
	all: 5
}

export const compoundType = {
	compounded: 1,
	notCompounded: 2,
	all: 3,
}

export const contextItems = {
	notDefined: 0,
	journal: 1,
	invoice: 2,
	manufacturing: 3,
	reconciliation: 4,
	all: 5
}

export const status = {
	notDefined: 0,
	posted: 1,
	notPosted: 2,
	all: 3
}

export const userType = {
	casher: 3,
	manager: 2,
	dataReader: 5
}

export const defaultLanguage = [
	{
		id: 1,
		name: i18n.t('StoreInfo.language.arabic')
	},
	{
		id: 2,
		name: i18n.t('StoreInfo.language.english')
	},
	{
		id: 3,
		name: i18n.t('StoreInfo.language.spanish')
	}
];

export const paymentWay = [
	{ id: 1, name: i18n.t('payment-method.cash') },
	{ id: 2, name: i18n.t('payment-method.debt') },
	{ id: 3, name: i18n.t('payment-method.creditCard') },
	{ id: 4, name: i18n.t('payment-method.internal') },
]

export const moneyType = {
	credit: 0,
	debit: 1
}

export const printedInvoiceType = {
	classic: 1,
	turkish: 2,
}
export const printedInvoiceTypes = [
	{ id: 1, name: i18n.t('printed-invoice-type.classic') },
	{ id: 2, name: i18n.t('printed-invoice-type.turkish') }
]

export const invoicesTypes = [
	{ id: 1, name: i18n.t('invoiceType.purchase') },
	{ id: 2, name: i18n.t('invoiceType.sale') },
	{ id: 4, name: i18n.t('invoiceType.sale-refund') },
]

export const auditLogType = {
	fetch: 0,
	create: 1,
	update: 2,
	delete: 3,
	post: 4,
	unPost: 5,
	closeCashJournal: 6,
}
export const itemConfigType = {
	extra: 0
}

export const actionType = {
	none: 0,
	read: 1,
	readAndWrite: 2,
}

export const permissionType = {
	configs: 3,
	currencies: 4,
	users: 6,
	stores: 11,
	accountStatement: 13,
	cashJournal: 14,
	closedCashJournal: 15,
	allCashJournal: 16,
	detailedDay: 17,
	dailyTable: 18,
	itemTree: 19,
	saleInvoice: 20,
	buyInvoice: 21,
	saleRefundInvoice: 22,
	allInvoices: 23,
	itemJournal: 24,
	allItemJournals: 25,
	itemStatement: 26,
	inventoryReport: 27,
	reports: 28,
	invoiceDiscount: 29,
	invoiceChangeAccount: 30,
	invoiceCredit: 31,
	invoiceInternal: 32,
	accountTree: 33,
	invoiceDebt: 34,
	invoiceEntriesDiscount: 35,
	closeJournal: 36,
}

export const operationType = {
	notDefined: 0,
	create: 1,
	read: 2,
	update: 3,
	delete: 4,
	post: 5,
	unPost: 6,
	close: 7,
	unClose: 8,
}

export const CRUD_ACTIONS =
	[operationType.create, operationType.read, operationType.update, operationType.delete];

export const defaultPermissions = [
	{ key: 'stores', permissionType: permissionType.stores },
	{ key: 'configs', permissionType: permissionType.configs },
	{ key: 'users', permissionType: permissionType.users },
	{ key: 'currencies', permissionType: permissionType.currencies },
	{ key: 'itemTree', permissionType: permissionType.itemTree },
	{ key: 'accountTree', permissionType: permissionType.accountTree },
	{ key: 'accountStatement', permissionType: permissionType.accountStatement },
	{ key: 'allInvoices', permissionType: permissionType.allInvoices },
	{ key: 'saleInvoice', permissionType: permissionType.saleInvoice },
	{ key: 'buyInvoice', permissionType: permissionType.buyInvoice },
	{ key: 'saleRefundInvoice', permissionType: permissionType.saleRefundInvoice },
	{ key: 'invoiceDiscount', permissionType: permissionType.invoiceDiscount },
	{ key: 'invoiceChangeAccount', permissionType: permissionType.invoiceChangeAccount },
	{ key: 'invoiceCredit', permissionType: permissionType.invoiceCredit },
	{ key: 'invoiceInternal', permissionType: permissionType.invoiceInternal },
	{ key: 'invoiceDebt', permissionType: permissionType.invoiceDebt },
	{ key: 'invoiceEntriesDiscount', permissionType: permissionType.invoiceEntriesDiscount },
	{ key: 'allCashJournal', permissionType: permissionType.allCashJournal },
	{ key: 'cashJournal', permissionType: permissionType.cashJournal },
	{ key: 'closedCashJournal', permissionType: permissionType.closedCashJournal },
	{ key: 'detailedDay', permissionType: permissionType.detailedDay },
	{ key: 'allItemJournals', permissionType: permissionType.allItemJournals },
	{ key: 'itemJournal', permissionType: permissionType.itemJournal },
	{ key: 'itemStatement', permissionType: permissionType.itemStatement },
	{ key: 'inventoryReport', permissionType: permissionType.inventoryReport },
	{ key: 'dailyTable', permissionType: permissionType.dailyTable },
	{ key: 'reports', permissionType: permissionType.reports },
	{ key: 'closeJournal', permissionType: permissionType.closeJournal },
];

export const fixedPermission = [
	{ permissionType: 1 }, // accounting
	{ permissionType: 2 }, // accounts
	{ permissionType: 4 }, // currencies
	{ permissionType: 5 }, // fundsFlow
	{ permissionType: 7 }, // system
	{ permissionType: 8 }, // permissions
	{ permissionType: 9 }, // items
	{ permissionType: 10 }, // itemsFlow
	{ permissionType: 12 }, // cashboxes
]